import React from 'react'
import { useTimer } from 'react-timer-hook';

const UseCron = ({ expiryTimestamp, handleAcceptCall }) => {
    const {
        seconds,
    } = useTimer({ expiryTimestamp, onExpire: handleAcceptCall });

    return (
        <span>{`Atender em (${seconds})`}</span>
    )
}


export { UseCron }